// extracted by mini-css-extract-plugin
export default {"title_text":"style_title_text__0ABbX","normal":"style_normal__PAznZ","large":"style_large__9130G","x-large":"style_x-large__33qtJ","description_text":"style_description_text__yHo3Q"};